import { Flex } from '@/_components';
import styles from './SplitView.module.css';
import { getClasses } from '@/_utils/classnames';
import type { FC } from 'react';
import type { SplitViewProps } from './SplitView.types';

export const SplitView: FC<SplitViewProps> = ({
  children,
  className,
  percentage = 50,
}) => {
  const splitViewClasses: string = getClasses(styles.splitView, className, {
    [styles.splitView33]: percentage === 33,
    [styles.splitView50]: percentage === 50,
    [styles.splitView66]: percentage === 66,
  });

  return (
    <Flex className={splitViewClasses} gap={10} isColumn={true}>
      {children}
    </Flex>
  );
};
